export function SET_ISLOGIN(state, data) {
  state.isLogin = data;
  localStorage.setItem("loginState", data);
}

export function SET_SHOWLOGIN(state, data) {
  state.showLogin = data;
}
export function SET_LOGINTO(state, data) {
  state.loginTo = data;
}

export function SET_SHOWREGISTER(state, data) {
  state.showRegister = data;
}

export function SET_USERINFO(state, data) {
  state.userInfo = data;
  localStorage.setItem("userInfo", data ? JSON.stringify(data) : "");
}

export function SET_LANG(state, data) {
  state.lang = data;
  localStorage.setItem("lang", data);
}

export function SET_REDIRECT_PATH(state, path) {
  state.redirectPath = path;
}
export function CLEAR_REDIRECT_PATH(state) {
  state.redirectPath = null;
}

export function SET_ISPUSHWHATSAPP(state, data) {
  state.isPushWhatsApp = data;
  localStorage.setItem("isPushWhatsApp", data);
}
